import React, { useState } from "react";
import "./AddImage.css";
import Button from "@mui/material/Button";
import { Grid, OutlinedInput } from "@mui/material";
import { addProductImage } from "../../api/products.api"; 
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { BeatLoader } from "react-spinners";

export function AddImage() {
  const [addImg, setAddImg] = useState("false");
  const [ loading, setLoading ] = useState(false);
  const [file, setFile] = useState([]);
  const { config2 } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  function handleChange(e) {
    // console.log(e.target.files);
    setFile(e.target.files);
  }
  console.log(file);
  let handleImage = () => {
    setAddImg(!addImg);
  };

  const handleSubmit = async () => {
    console.log("===this is for checking", file);
    const newFiles = Object.entries(file);
    setLoading(true);
    console.log(newFiles);
    for await(let item of newFiles ) {
      addProductImage({ product_id: location?.state?.data?.product_id, file: item[1] }, config2);
    }
    // newFiles.forEach(el => {
    // })
    navigate("/products")
    setLoading(false);
  }

  return (
    <div className="Container">
      {addImg ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            paddingTop: "10rem",
          }}
        >
          <h2>Click here to add Images?</h2>
          <Button variant="contained" onClick={handleImage}>
            Yes
          </Button>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            paddingTop: "10rem",
          }}
        >
          <h2>Select the images and submit</h2>
          <input 
            type="file" 
            multiple 
            onChange={handleChange} 
          />
          <Button
            variant="contained"
            onClick={handleSubmit}
          >
            Submit
          </Button>
      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
          <Grid container spacing={2}>
              {Array.from(file).map((item) => {
                return (
            <Grid item md={4}>
                  <img src={item ? URL.createObjectURL(item) : null} alt="" />
            </Grid>
                );
              })
              }
          </Grid>}
        </div>
      )}
    </div>
  );
}

// export default AddImage;
